import { basisContestFields } from "@/composables/fields/basisContestFields";


export function useBasisFields () {
  return {
    basisContestFields
  }
}
